<template>
  <footer class="border-top text-muted">
    <div class="container text-center">
      {{ project_name_local }} &copy; {{ currentYear }} 
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    project_name: {
      type: String,
      default: 'Global ITS', // default value
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      project_name_local: this.project_name
    };
  },
  mounted() {
    //console.log('Received company_name prop:', this.company_name);
  },
  watch: {
    project_name_local(newValue, oldValue) {
      //console.log('Project name changed from', oldValue, 'to', newValue);
    },
  }
}
</script>

<style scoped>
/* Footer specific styles */
.border-top {
  background-color: #00013A;
  padding: 20px;
  font-size: 18px;
}

.container {
  color: #E8E9EB;
}
</style>